import React from "react";
import PlantsTable from "../../../Project/plant";

export default function EstimationTab2() {
  return <PlantsTable isEstimation />;
}
